<template>
  <pict
    class="book-share__image m-auto w-full"
    block-name="book-share"
    image-class="w-full"
    :default="imageProps.default"
    :sources="imageProps.sources"
    :alt="$t('alt')"
  />
</template>

<script>
import Pict from "@/shared/pict"

import imageL from "../images/space.png"
import imageL2x from "../images/space@2x.png"
import imageS from "../images/space_s.png"
import imageS2x from "../images/space_s@2x.png"

export default {
  name: "SpaceImage",
  components: {
    Pict
  },
  computed: {
    imageProps() {
      return {
        default: {
          src: imageL,
          srcset: {
            "2x": imageL2x
          }
        },
        sources: [
          {
            media: "s",
            src: imageS,
            srcset: {
              "2x": imageS2x
            }
          },
          {
            media: "m",
            src: imageS,
            srcset: {
              "2x": imageS2x
            }
          }
        ]
      }
    }
  },
  i18n: {
    messages: {
      en: {
        alt: "Three people sitting on a sofa and looking at a book together"
      },
      de: {
        alt: "Drei Menschen auf einem Sofa, die zusammen in ein Buch schauen"
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.book-share {
  ::v-deep &__image {
    width: auto;
  }
}
</style>
